import { render, staticRenderFns } from "./AppMenuFooter.vue?vue&type=template&id=60bd81a6&scoped=true"
import script from "./AppMenuFooter.vue?vue&type=script&lang=js"
export * from "./AppMenuFooter.vue?vue&type=script&lang=js"
import style0 from "./AppMenuFooter.vue?vue&type=style&index=0&id=60bd81a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd81a6",
  null
  
)

/* custom blocks */
import block0 from "./AppMenuFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports